import { render, staticRenderFns } from "./SGShardedClusterStatus.vue?vue&type=template&id=8e17354e&scoped=true"
import script from "./SGShardedClusterStatus.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterStatus.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterStatus.vue?vue&type=style&index=0&id=8e17354e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e17354e",
  null
  
)

export default component.exports